import { render, staticRenderFns } from "./AssignPatientToLicenseDrawer.vue?vue&type=template&id=5a78a5c1"
import script from "./AssignPatientToLicenseDrawer.vue?vue&type=script&lang=js"
export * from "./AssignPatientToLicenseDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports